import { CleanerOtpForm } from '@/features/cleaner/otp-form';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/(cleaner)/_auth-layout/cleaner/otp')({
  component: OtpFormWrapper,
  validateSearch: z.object({
    email: z.email(),
  }),
});

function OtpFormWrapper() {
  const { email } = Route.useSearch();
  return <CleanerOtpForm email={email} />;
}
